// extracted by mini-css-extract-plugin
module.exports = {"info":"PlywoodInfo_info__kpQAc","info__left":"PlywoodInfo_info__left__awxFh","info__right":"PlywoodInfo_info__right__e544z"};